import { render, staticRenderFns } from "./patient-file.vue?vue&type=template&id=c4261f80&scoped=true&"
import script from "./patient-file.vue?vue&type=script&lang=ts&"
export * from "./patient-file.vue?vue&type=script&lang=ts&"
import style0 from "./patient-file.vue?vue&type=style&index=0&id=c4261f80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4261f80",
  null
  
)

export default component.exports